import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// THUNK
export const getSystemsList = createAsyncThunk(
    'systems/getSystems',
    async ({ accountId, token, length, start, search }, { rejectWithValue }) => {
        try {
            // Logica di crittografia della password
            let url = `${import.meta.env.VITE_API_BASE_URL}/systems/list?accountId=${accountId}&length=${length}&start=${start}&search.value=${encodeURIComponent(search || "")}`;
            const headers = {
                'Content-Type': 'application/json',
                'auth-token': token
            };
            const options = { method: 'GET', headers };
            const response = await fetch(url, options);
            if (!response.ok) {
                const error = await response.json();
                return rejectWithValue({
                    message: error.message || `Errore sconosciuto.`
                })
            }
            const result = await response.json();
            return result
        } catch (error) {
            return rejectWithValue({
                message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
            });
        }
    })

const initialState = {
    data: null,
    isLoading: false,
    error: null
};

const systemsSlice = createSlice({
    name: 'systems',
    initialState,
    reducers: {
        clearSystemsData: (state) => {
            state.data = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSystemsList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSystemsList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getSystemsList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento di systems list.";
                state.isLoading = false;
            })
    }
});

// Selector
export const selectSystemsData = (state) => state.systems.data;
export const selectSystemsLoading = (state) => state.systems.isLoading;
export const selectSystemsError = (state) => state.systems.error;

export const { clearSystemsData } = systemsSlice.actions;
export default systemsSlice.reducer;
